import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

import './Grade.css';

export default function Grade() {
    return (
        <Container className="gradeContainer worldwide">
            <p className="gradeTitle">
                <span className="bracket">{'<'}</span>
                    Grade
                <span className="bracket">{'/>'}</span>
            </p>
            <p className="gradeSubTitle">Află mai multe despre examenul de Grade</p>
            <Row>
                <p className="gradeDescription">
                    Examenul de grade II și I pentru Informatică și TIC în România reprezintă etape superioare în cariera
                    didactică, organizate anual de Ministerul Educației, pentru profesorii din învățământul preuniversitar
                    care doresc să-și avanseze poziția profesională și să-și confirme competențele la un nivel avansat.
                    <br/>
                    Proba scrisă pentru gradele II și I evaluează în profunzime atât cunoștințele de specialitate
                    (programare avansată, algoritmică complexă, baze de date, rețele, sisteme informatice, tehnologii
                    educaționale moderne etc.), cât și abilitățile didactice, inclusiv planificarea și evaluarea procesului
                    educațional, metodologii de predare și adaptarea la nevoile elevilor.
                </p>
                <p className="gradeText1">Programa de Informatică a Examenului de Grade: <a href="/grade/Programă Informatică Definitivat, Gradul 2 și Gradul 1.pdf" className="fixColor" target="blank">AICI</a></p>
                <p className="gradeText1">Programa de Pedagogie a Examenului de Grade: <a href="/grade/Programă Pedagogie Definitivat, Gradul 2 și Gradul 1.pdf" className="fixColor" target="blank">AICI</a></p>
            </Row>
        </Container>
    )
}